export const GET_SIGNUP_REQUEST = "GET_SIGNUP_REQUEST";
export const GET_SIGNUP_SUCCESS = "GET_SIGNUP_SUCCESS";
export const GET_SIGNUP_FAILURE = "GET_SIGNUP_FAILURE";
